import { render, staticRenderFns } from "./DeclarationDataComponent.vue?vue&type=template&id=16e38850&"
import script from "./DeclarationDataComponent.vue?vue&type=script&lang=js&"
export * from "./DeclarationDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationDataComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports